export const getLayoutClassName = (layout, componentClass) => {
  let className = "";

  switch (layout) {
    case "grid":
      className = `${componentClass} ${componentClass}-grid`;
      break;

    default:
      className = `${componentClass}`;
      break;
  }

  return className;
};

export const getContainerClassName = (layout, componentClass) => {
  let className = "";

  switch (layout) {
    case "grid":
      className = `container ${componentClass} ${componentClass}--grid`;
      break;

    default:
      className = `${componentClass}`;
      break;
  }

  return className;
};
